import React, { useEffect, useMemo, useState } from 'react';
import { Card, Container, Row, Col, Form, Button, Table, Modal, InputGroup, FormControl } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Breadcrums from '../../components/company_panel/common/breadcrumbs';
import { formatToTwoDecimals, getBrandId, getCompany } from '../../helpers/commonFunctions';
import { GetAllSuppliers, getInventoriesFromSupplier } from '../../services/company_panel/supplierService';
import { GetBrandOutletsList } from '../../services/company_panel/outletService';
import { CreatePurchaseOrder } from '../../services/company_panel/purchaseOrderService';
import Swal from 'sweetalert2';
import { useNavigate, useParams } from 'react-router-dom';
import { Link, useHistory } from 'react-router-dom';
import { Loader } from 'semantic-ui-react';
import Select from 'react-select';
import CustomDatetimepickerNew from '../../helpers/customDatePickerNew';

const outletSelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 42,
    borderRadius: 4,
    fontSize: 14,
    backgroundColor: '#fff',
    borderColor: state.isFocused ? '#2f9bff' : '#e8e8e8',
    boxShadow: state.isFocused ? '0 0 0 3px rgba(47, 155, 255, 0.15)' : 'none',
    '&:hover': { borderColor: '#2f9bff' },
  }),
  valueContainer: (base) => ({ ...base, padding: '2px 12px' }),
  placeholder: (base) => ({ ...base, color: '#9aa0a6', fontSize: 14 }),
  singleValue: (base) => ({ ...base, color: '#2c1d37' }),
  input: (base) => ({ ...base, color: '#2c1d37', margin: 0, padding: 0 }),
  indicatorSeparator: () => ({ display: 'none' }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  option: (base, state) => ({
    ...base,
    fontSize: 14,
    backgroundColor: state.isSelected ? '#2f9bff' : state.isFocused ? '#eaf4ff' : '#fff',
    color: state.isSelected ? '#fff' : '#2c1d37',
  }),
};

const OrderAdd = () => {
  const [supplier, setSupplier] = useState();
  const [suppliers, setSuppliers] = useState([]);
  const [outlets, setOutlets] = useState([]);
  const [inventories, setInventories] = useState([]);
  const [selectedOutlet, setSelectedOutlet] = useState('');
  const [deliveryDate, setDeliveryDate] = useState('');
  const [arrayData, setArrayData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]); // New state for selected items
  const [tableItems, setTableItems] = useState([]); 
  const [isItem, setIsItem] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loader, setLoader] = useState(true);
  const [isBrandChanged, setIsBrandChanged] = useState(false);

  const navigate = useNavigate();
  // page the user was on in the list (carried in the route) so we return there
  const params = useParams();
  const listPage = params?.pgno || 1;
  const breadcrumbs = [
    { title: "Purchase Order", url: `/company/store_manager/purchase_order/list/${listPage}` },
    { title: "Create Order", url: "" },
  ];

  useMemo(() => {
    document.addEventListener('brand-changed', function () {
      setIsBrandChanged(!isBrandChanged);
    });
  });

  useEffect(() => {
    GetAllSuppliers({ brand_id: getBrandId() }).then(data => {
      setSuppliers(data?.data?.response || []);
      setLoader(false);
    }).catch(error => {
      console.log("error ====> ", error);
    });

    GetBrandOutletsList({ brand_ids: JSON.stringify([getBrandId()]) }).then(data => {
      setOutlets(data?.data?.response || []);
      setLoader(false);
    }).catch(error => {
      console.log("error ====> ", error);
    });
    setArrayData([]);
    setTableItems([]);
  }, [isBrandChanged]);

  const getInventories = () => {
    if (supplier) {
      getInventoriesFromSupplier({ id: supplier }).then(data => {
        const supplierInventoriesRelations = data?.data?.response?.rows || [];
        setInventories(supplierInventoriesRelations);
      }).catch(error => {
        console.log("error=====>", error);
      });
    }
  };
  const getTodayDate = () => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const year = tomorrow.getFullYear();
    let month = tomorrow.getMonth() + 1;
    let day = tomorrow.getDate();

    if (month < 10) {
      month = ` 0${month}`;
    }
    if (day < 10) {
      day = `0${day}`;
    }

    return ` ${year} -${month} -${day}`;
  };

  const validationSchema = Yup.object().shape({
    brand_id: Yup.string().required('Supplier is required'),
    outlet: Yup.string().required('Outlet is required'),
    deliveryDate: Yup.date()
      .required('Delivery Date is required')
  });

  const formik = useFormik({
    initialValues: {
      deliveryDate: '',
    },
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      const formData = new FormData();
      formData.append("supplier_id", supplier);
      formData.append("outlet_id", selectedOutlet);
      formData.append("delivery_date", values.deliveryDate);
      formData.append("inventories", JSON.stringify(tableItems));
      formData.append("company_id", getCompany().company_id);
      formData.append("final_price", final_price);
      CreatePurchaseOrder(formData).then(response => {
        setSubmitting(false);
        setSubmitted(false);
        if (response.data.status === 1 || response.data.status === "1") {
          Swal.fire({
            customClass: 'swal-wide',
            icon: 'success',
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500,
            toast: true,
            position: 'top-right',
          });
          setTimeout(() => {
            navigate(`/company/store_manager/purchase_order/list/${listPage}`);
          }, 1000);
        } else {
          Swal.fire({
            customClass: 'swal-wide',
            icon: 'error',
            title: response.data.message,
            showConfirmButton: false,
            timer: 5000,
            toast: true,
            position: 'top-right',
          });
          setSubmitted(false);
        }
      }).catch(error => {
        console.log("error ====> ", error);
      });
    },
  });

  const handleDecrement = (index) => {
    const updatedArrayData = [...tableItems];
    if (updatedArrayData[index].quantity > 1) {
      updatedArrayData[index].quantity -= 1;
      updatedArrayData[index].total_price = updatedArrayData[index].quantity * updatedArrayData[index].price;
      setTableItems(updatedArrayData);
    }
  };

  const handleIncrement = (index) => {
    const updatedArrayData = [...tableItems];
    updatedArrayData[index].quantity = Number(updatedArrayData[index].quantity) + 1;
    updatedArrayData[index].total_price = updatedArrayData[index].quantity * updatedArrayData[index].price;
    setTableItems(updatedArrayData);
  };

  const handleRemoveItem = (index) => {
    const updatedArrayData = tableItems.filter((_, i) => i !== index);
    setTableItems(updatedArrayData);
  };

  const handlePriceChange = (price, index) => {
    if (price < 0 || price != Math.floor(price)) {
      return;
    }
    const updatedArrayData = [...tableItems];
    updatedArrayData[index].price = price;
    updatedArrayData[index].total_price = updatedArrayData[index].quantity * updatedArrayData[index].price;
    setTableItems(updatedArrayData);
  }

  const handleAddHandler = (val) => {
    const existingItemIndex = arrayData.findIndex(item => item.inventory_id === val.inventory.id);

    if (existingItemIndex !== -1) {
      // If the item is already selected, remove it
      const updatedArrayData = arrayData.filter(item => item.inventory_id !== val.inventory.id);
      setArrayData(updatedArrayData);
    } else {
      // If the item is not selected, add it
      setArrayData([...arrayData, {
        inventory_id: val.inventory.id,
        name: val.inventory?.item_name,
        price: val.inventory.raw_material_price,
        quantity: 1,
        total_price: val.inventory.raw_material_price,
        can_change_later: val.inventory.can_change_later,
        uom: val.inventory.uom.uom
      }]);
    }
  };

  // const handleQuantityChange = (e, index) => {
  //   const newArrayData = [...arrayData];
  //   const newQuantity = parseInt(e.target.value, 10);

  //   if (newQuantity >= 1 && newQuantity <= (newArrayData[index].old_quantity - newArrayData[index].minimum_stock_limit)) {
  //     newArrayData[index].quantity = newQuantity;
  //     setArrayData(newArrayData);
  //   }
  // };
  // const handleQuantityChange = (e, index) => {
  //   // Convert input value to a number
  //   let newValue = e.target.value;

  //   // ✅ Allow empty string (so user can clear input)
  //   if (newValue === "") {
  //     // update state with ""
  //     newValue = 0;
  //   }

  //   // ✅ Allow:
  //   // integers (including 0)
  //   // decimals up to 2 places
  //   // values like .5
  //   const validNumber = /^(\d+(\.\d{0,2})?|\.\d{1,2})$/;

  //   if (!validNumber.test(newValue)) return;

  //   const numericValue = Number(newValue);

  //   // ❌ Block negative numbers (0 is allowed)
  //   if (numericValue < 0) return;

  //     // Create a new array to update state
  //     const updatedArrayData = [...tableItems];
  //     updatedArrayData[index].quantity = numericValue;
  //     updatedArrayData[index].total_price = numericValue * updatedArrayData[index].price;

  //     // Update the state with the new array
  //     setTableItems(updatedArrayData);
  //   };
    // const handleQuantityChange = (e, index) => {
    // // Convert input value to a number
    // let newValue = e.target.value;

    // const numericValue = Number(newValue);
    // // ❌ Block negative numbers (0 is allowed)
    // if (numericValue < 0) return;

    // // ✅ Allow:
    // // integers (including 0)
    // // decimals up to 2 places
    // // values like .5
    // const validNumber = /^(\d+(\.\d{0,2})?|\.\d{1,2})$/;

    // if (!validNumber.test(newValue)) return;



    //   // Create a new array to update state
    //   const updatedArrayData = [...tableItems];
    //   updatedArrayData[index].quantity = numericValue;
    //   updatedArrayData[index].total_price = numericValue * updatedArrayData[index].price;

    //   // Update the state with the new array
    //   setTableItems(updatedArrayData);
    // };
  const handleQuantityChange = (e, index) => {
  let newValue = e.target.value;

  // ✅ Allow clearing input
  if (newValue === "") {
    const updatedArrayData = [...tableItems];
    updatedArrayData[index].quantity = "";
    updatedArrayData[index].total_price = 0;
    setTableItems(updatedArrayData);
    return;
  }

  // ✅ Allow non-negative numbers with up to 2 decimals
  const validNumber = /^(\d+(\.\d{0,2})?|\.\d{1,2})$/;

  if (!validNumber.test(newValue)) return;

  const numericValue = Number(newValue);

  // ❌ Block negative numbers
  if (numericValue < 0) return;

  const updatedArrayData = [...tableItems];
  updatedArrayData[index].quantity = newValue; // keep original string for typing
  updatedArrayData[index].total_price =
    numericValue * updatedArrayData[index].price;

  setTableItems(updatedArrayData);
};

  const handleAddItem = () => {
    const updatedArrayData = [...arrayData, ...selectedItems];
    setArrayData(updatedArrayData);
    setTableItems(updatedArrayData);
    setSelectedItems([]);
    setShowModal(false);
    setIsItem(true);
  };

  // searchable outlet list: label carries the short code so it is matched too
  const outletOptions = useMemo(() => (outlets || []).map((outlet) => ({
    value: String(outlet.id),
    label: `${outlet?.outlet_name}${outlet?.short_code ? ` (${outlet?.short_code})` : ''}`,
    name: outlet?.outlet_name || '',
    short_code: outlet?.short_code || '',
  })), [outlets]);

  const filterOutlet = (option, input) => {
    if (!input) return true;
    const term = input.trim().toLowerCase();
    return `${option.data.name} ${option.data.short_code}`.toLowerCase().includes(term);
  };

  // same floor the native input had: today onwards
  const minDeliveryDate = (() => {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    return date;
  })();





  let final_price = 0;
  return (
    <div>
      <div className="page-header d-flex align-items-center">
        <div className="page-header-left">
          <Breadcrums data={breadcrumbs} />
          <h4>Purchase order</h4>
        </div>
      </div>

      <div className="row row-sm">
        <div className="col-lg-12">
          <Card className="custom-card p-0">
            <Card.Body>
              <Form onSubmit={formik.handleSubmit}>
                <Form.Group id="outletSelect" className="row">
                  <div className="col-lg-6 form-group mt-3">
                    <label htmlFor="brand_id" className="text-left">
                      {suppliers.length === 0 && (loader == false || loader == 'false') ?
                        <div className="alert alert-warning">
                          There is no supplier created yet. Please{' '}
                          <Link to="/company/raw_materials/supplier_manage/add">
                            create a supplier
                          </Link>{' '}
                          to assign to the purchase order.
                        </div>
                        : null}
                      Supplier: <span className="requirestar">*</span>
                    </label>


                    <InputGroup style={{ width: '100%', marginBottom: '20px' }}>
                      <Form.Control
                        as="select"
                        id="brand_id"
                        name="brand_id"
                        value={formik.values.brand_id}
                        onChange={(event) => {
                          setSupplier(event.target.value);
                          formik.handleChange(event);
                        }}
                        onBlur={formik.handleBlur}
                        isInvalid={formik.touched.brand_id && formik.errors.brand_id}
                      >

                        <option value="">Select Supplier</option>
                        {suppliers.length ? suppliers.map((supplier) => (
                          <option key={supplier.id} value={supplier.id}>{supplier.name}</option>
                        )) : ''}
                      </Form.Control>
                      {formik.touched.brand_id && formik.errors.brand_id && (
                        <Form.Control.Feedback type="invalid">
                          {formik.errors.brand_id}
                        </Form.Control.Feedback>
                      )}
                    </InputGroup>
                  </div>


                  <div className="col-lg-6 form-group mt-3">
                    {/* Outlet Warning Message */}
                    {outlets.length === 0 && (loader == false || loader == 'false') ?
                      <div className="alert alert-warning">
                        There is no outlet created yet. Please{' '}
                        <Link to="/company/business/outlet/add">
                          create an outlet
                        </Link>{' '}
                        to assign to the purchase order.
                      </div>
                      : null}

                    {/* Outlet Field */}
                    <label htmlFor="outlet" className="text-left">
                      Outlet: <span className="requirestar">*</span>
                    </label>
                    <div style={{ width: '100%', marginBottom: '20px' }}>
                      <Select
                        inputId="outlet"
                        name="outlet"
                        classNamePrefix="react-select"
                        placeholder="Search outlet by name or short code"
                        isSearchable
                        isClearable
                        options={outletOptions}
                        filterOption={filterOutlet}
                        value={outletOptions.find((option) => option.value === String(formik.values.outlet)) || null}
                        onChange={(selected) => {
                          setSelectedOutlet(selected ? selected.value : '');
                          formik.setFieldValue('outlet', selected ? selected.value : '');
                        }}
                        onBlur={() => formik.setFieldTouched('outlet', true)}
                        noOptionsMessage={({ inputValue }) => inputValue ? `No outlet matching "${inputValue}"` : 'No outlets found'}
                        menuPortalTarget={document.body}
                        menuPlacement="auto"
                        maxMenuHeight={260}
                        styles={outletSelectStyles}
                      />
                      {formik.touched.outlet && formik.errors.outlet && (
                        <span className="text-danger d-flex text-left">{formik.errors.outlet}</span>
                      )}
                    </div>
                  </div>


                  {/* Delivery Date Input */}
                  <div className="col-lg-6 form-group mt-3">
                    <label htmlFor="deliveryDate" className="text-left">
                      Delivery Date: <span className="requirestar">*</span>
                    </label>
                    <div style={{ width: '100%', marginBottom: '20px' }}>
                      <CustomDatetimepickerNew
                        fieldname="deliveryDate"
                        value={formik.values.deliveryDate}
                        placeholder="Select delivery date"
                        minDate={minDeliveryDate}
                        setField={(fieldname, date) => {
                          // the API takes a plain YYYY-MM-DD, so keep the local day
                          const value = date ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}` : '';
                          setDeliveryDate(value);
                          formik.setFieldValue(fieldname, value);
                        }}
                        setFieldTouched={formik.setFieldTouched}
                      />
                      {formik.touched.deliveryDate && formik.errors.deliveryDate && (
                        <span className="text-danger d-flex text-left">{formik.errors.deliveryDate}</span>
                      )}
                    </div>
                  </div>
                </Form.Group>

                {
                  supplier 
                  ?
                    // <div className="d-flex justify-content-between align-items-center mt-4 mb-4">
                    //   <h4 style={{ fontSize: "18px" }}>Items List</h4>

                    //   <b onClick={() => { setShowModal(true); getInventories(); setArrayData(tableItems) }} className="cursor-pointer">
                    //     <FontAwesomeIcon icon={faPlus} className="me-2" />
                    //     Browse Items
                    //   </b>
                    // </div> 
                     <div className="d-flex justify-content-between align-items-center mt-4 mb-4">
                        <h2 className="items-title">Items List</h2>

                        <button
                          type="button"
                          onClick={() => { setShowModal(true); getInventories(); setArrayData(tableItems) }}
                          className="btn btn-outline-primary browse-items-btn"
                        >
                          <FontAwesomeIcon icon={faPlus} />
                          <span>Browse Items</span>
                        </button>
                      </div>
                  : null
                }

                {tableItems.length > 0 && <table className='table table-custom m-0'>
                  <thead>
                    <tr>
                      <th>Item Name</th>
                      <th>Quantity</th>
                      <th>Unit</th>
                      <th>Price</th>
                      <th className='text-end'>Total Price</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      isItem && tableItems.map((item, index) => {
                        final_price += Number(item.total_price);
                        return <tr key={index}>
                          <td>{item.name}</td>
                          <td className="d-flex align-items-center">
                            <Button variant="outline-secondary" size="sm" onClick={() => handleDecrement(index)}>-</Button>
                            <span className="mx-2">
                              <input
                                type="number"
                                value={item.quantity}
                                onChange={(e) => handleQuantityChange(e, index)}
                                className="form-control mx-2"
                                style={{ width: '60px' }}
                                max={item.old_quantity - Number(item.minimum_stock_limit)}
                              />

                            </span>
                            <Button variant="outline-secondary" size="sm" onClick={() => handleIncrement(index)}>+</Button>
                          </td>
                          <td>{item.uom}</td>
                          <td>
                            <InputGroup>
                              <InputGroup.Text style={{ borderLeft: '1px solid #e8e8e8' }}>SAR</InputGroup.Text>
                              <Form.Control
                                type="number"
                                value={item.price}
                                disabled={item.can_change_later == false}
                                onChange={(event) => { handlePriceChange(event.target.value, index) }}

                              />
                            </InputGroup>
                          </td>
                          
                          <td className='text-end'>{formatToTwoDecimals(Number(item.total_price))} SAR</td>
                          <td>
                            <Button variant='danger' size='sm' onClick={() => handleRemoveItem(index)}>
                              <FontAwesomeIcon icon={faTimes} />
                            </Button>
                          </td>
                        </tr>
                      })
                    }
                    <tr>
                      <td colSpan="4" className="text-end" style={{borderBottom: 'none', textDecoration: 'none'}}><strong>Final Price:</strong></td>
                      <td colSpan="1" className="text-end" style={{borderBottom: 'none', textDecoration: 'none', height: "63px", padding: "15px"}}>{formatToTwoDecimals(Number(final_price))}  SAR</td>
                    </tr>
                  </tbody>

                </table>}

                {/* Modal for Item Selection */}
                <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
                  <Modal.Header closeButton>
                    <Modal.Title style={{ fontSize: '20px' }}>Browse Items</Modal.Title>
                  </Modal.Header>

                  <Modal.Body className="modal-scroll-body">
                    {inventories.length === 0 && (loader == false || loader == 'false') ?
                      <div className="alert alert-warning">
                        There is no inventories assigned to this supplier yet. Please{' '}
                        <Link to={`/company/raw_materials/supplier_manage/1/edit/${supplier}`}>
                          assign inventories to this supplier
                        </Link>{' '}
                      </div>
                      : <>
                        <FormControl type="text"
                          placeholder="Search items"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          className="mb-3"
                        />

                        <div className="table-scroll">
                          <table className='table table-custom'>
                            <thead>
                              <tr>
                                <th>Select</th>
                                <th>Id</th>
                                <th>Item Name</th>
                                <th>SKU</th>
                                <th>Price</th>
                              </tr>
                            </thead>
                            <tbody>
                              {(() => {
                                const filteredInventories = inventories.filter(val => {
                                  const search = searchTerm.toLowerCase();

                                  return (
                                    val.inventory?.id?.toString().toLowerCase().includes(search) ||
                                    val.inventory?.item_name?.toLowerCase().includes(search) ||
                                    val.inventory?.sku?.toLowerCase().includes(search)
                                  );
                                });

                                if (filteredInventories.length === 0) {
                                  return (
                                    <tr>
                                      <td colSpan="5" className="text-center">Data not found</td>
                                    </tr>
                                  );
                                }

                                return filteredInventories.map((val, index) => (
                                  <tr key={index}>
                                    <td>
                                      <Form.Check
                                        type="checkbox"
                                        onChange={() => handleAddHandler(val)}
                                        checked={arrayData.some(item => item.inventory_id === val.inventory.id)}
                                      />
                                    </td>
                                    <td>{val.inventory?.id}</td>
                                    <td>{val.inventory?.item_name}</td>
                                    <td>{val.inventory?.sku}</td>
                                    <td>{val.inventory?.raw_material_price}</td>
                                  </tr>
                                ));
                              })()}
                            </tbody>

                          </table>
                        </div>
                      </>
                    }
                  </Modal.Body>
                  <Modal.Footer>
                    <button className='btn btn-outline-primary' onClick={() => setShowModal(false)}>
                      Cancel
                    </button>
                    <Button variant="primary" onClick={handleAddItem}>
                      Add Item
                    </Button>
                  </Modal.Footer>
                </Modal>

                <Button
                  variant="primary"
                  type="submit"
                  className="mt-3"
                  disabled={tableItems.length === 0 || inventories.length === 0} // Disable if no items or inventories
                >
                  Create Order
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default OrderAdd;
